import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Element, scroller} from "react-scroll";
import {cartInfoSelector} from "../../ducks/cart-info";
import Grid from "@material-ui/core/Grid";
import H from "../../../common/Typography/H";
import P from "../../../common/Typography/P";
import Button from "../../../common/Button";
import BasketIcon from "../../../common/Icons/BasketIcon";
import AddIcon from "../../../common/Icons/AddIcon";

import styles from "./cart-info.module.scss";

function CartInfo(props) {
  const {
    cartInfo,
    cartInfo: {giftWrappingPath, path, size, total}
  } = props;
  const scrollHandler = () => {
    scroller.scrollTo(`cart-info`, {
      duration: 800,
      delay: 0,
      offset: -100,
      smooth: `easeInOutQuart`
    });
  };
  useEffect(() => {
    window.addEventListener(`load`, scrollHandler);
    return () => {
      window.removeEventListener(`load`, scrollHandler);
    };
  }, []);
  return cartInfo.path ? (
    <Grid container className={styles.root}>
      <Element name="cart-info" />
      <Grid item md={7} xs={12} className={styles.cart}>
        <H level={2}>Товар добавлен в корзину</H>
        <div className={styles.price}>
          <Button href={path} size="medium" variant="contained" style="danger">
            <BasketIcon className={styles.basketIcon} />
            <span>Оформить заказ</span>
          </Button>
          <P>
            В корзине товаров {size} шт. на {total} ₽
          </P>
        </div>
      </Grid>
      {giftWrappingPath ? (
        <Grid item md={5} xs={12} className={styles.gift}>
          <H level={2}>Это подарок?</H>
          <Button
            href={giftWrappingPath}
            size="medium"
            variant="contained"
            style="primary"
          >
            <AddIcon className={styles.addIcon} />
            <span>Упаковать</span>
          </Button>
        </Grid>
      ) : null}
    </Grid>
  ) : null;
}

CartInfo.propTypes = {
  cartInfo: PropTypes.shape({
    giftWrappingPath: PropTypes.string,
    path: PropTypes.string,
    size: PropTypes.number,
    total: PropTypes.number
  })
};

export default connect((state) => ({
  cartInfo: cartInfoSelector(state)
}))(CartInfo);
